import script from "./SelectComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectComponent.vue?vue&type=script&setup=true&lang=js"

import "./SelectComponent.vue?vue&type=style&index=0&id=62418b9f&lang=css"

const __exports__ = script;

export default __exports__